<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main no-drag" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <v-nav-menu
      :navMenuItems="navMenuItems"
      title="Vuexy"
      parent=".layout--main"/>

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"/>

      <!-- Navbar -->
      <template>
        <div class="relative">

          <div class="vx-navbar-wrapper m-main p-0">

            <div class="w-full flex"
                 style="background:#1E0D61; color:#cdcdcd; height:54px; padding:13px 16px; align-items: center;"
                 @click="moveMyPage">
              <img src="@/assets/images/logo/m-maot-logo.svg" alt="login" class="mx-auto">
              <vs-spacer/>
              <span>{{ $t('nav.profile.hello') }} {{ userInfo.name }}님</span>
            </div>
          </div>
        </div>
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content m-main">

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                           v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top"/>
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"
                             @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"/>
              </transition>
            </div>
          </div>
        </div>
      </div>


      <footer class="the-footer flex-wrap justify-between p-0"
              style="position: fixed; left:0; right:0; bottom:0; height:60px; z-index:41001;
                      background: #FFFFFF; box-shadow: 1px -1px 8px rgba(0, 0, 0, 0.15);">
        <div class="w-full h-full"
             style="display: grid; grid-template-columns: 0.6fr 1.4fr 1fr 1fr 1fr; align-items: center; justify-content: center; text-align: center; padding:0 16px; ">
          <div @click.stop="gnbClickMenu(0)">
            <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon"/>
          </div>
          <div @click.stop="gnbClickMenu(1)"><span style="font-weight: 500; font-size: 15px; color: #D80000;">긴급콜</span>
          </div>
          <div @click.stop="gnbClickMenu(2)"><img src="@/assets/images/menu/menu-camera.svg" alt="login"
                                                  style="margin-top:-20px; width:72px;"></div>
          <div @click.stop="gnbClickMenu(3)"><span style="font-weight: 500; font-size: 15px; color: #353535;">알림</span>
          </div>
          <div @click.stop="gnbClickMenu(4)"><span
            style="font-weight: 500; font-size: 15px; color: #353535;">출역체크</span></div>

        </div>
      </footer>
    </div>
  </div>
</template>


<script>
import BackToTop from 'vue-backtotop'
//import navMenuItems        from '@/layouts/main/sidebarItems'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

export default {
  components: {
    BackToTop,
    TheFooter,
    TheNavbarVertical,
    VNavMenu
  },
  data () {
    return {
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      sidebarItems: [],
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    }
  },
  computed: {
    bodyOverlay () {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark () {
      return this.$store.state.theme === 'dark'
    },
    layoutTypeClass () {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType () {
      return this.$store.state.mainLayoutType
    },
    navbarClasses () {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    navMenuItems () {
      return this.sidebarItems
    },
    userInfo () {
      return this.$store.state.auth.userInfo
    }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    renameKey (obj, oldKey, newKey) {
      obj[newKey] = obj[oldKey]
      delete obj[oldKey]
    },
    async loadMyProjectList () {
      const page = 1
      const perPage = 100
      const onlyMe = 1

      await this.$store.dispatch('project/LOAD_PROJECT_LIST', {
        page,
        perPage,
        onlyMe
      })

      // 게시물 불러오기
      const projectListInfo = this.$store.state.project.projectListInfo
      const myProjectList = projectListInfo.data
      return myProjectList
    },
    async loadMenuList () {
      await this.$store.dispatch('menu/LOAD_MENU_LIST')
      const menuData = this.$store.state.menu.list

      menuData.forEach((obj) => {
        if (obj.children.length === 0) {
          delete (obj.children)
        }
      })
      const strMenuData = JSON.stringify(menuData)
      const newMenuData = JSON.parse(strMenuData.replace(/children/gi, 'submenu'))

      const approval = {
        url: null,
        name: '결재',
        icon: 'CheckCircleIcon',
        submenu: [
          {
            url: '/approval-write',
            name: '결재문서 작성',
            slug: 'page-approval-write',
            icon: 'FileIcon'
          },
          {
            url: '/approval-await',
            name: '결재대기함',
            slug: 'page-approval-await',
            icon: 'FileIcon'
          },
          {
            url: '/approval-process',
            name: '결재진행함',
            slug: 'page-approval-process',
            icon: 'FileIcon'
          },
          {
            url: '/approval-complete',
            name: '완료문서함',
            slug: 'page-approval-complete',
            icon: 'FileIcon'
          },
          {
            url: '/approval-reject',
            name: '반려문서함',
            slug: 'page-approval-reject',
            icon: 'FileIcon'
          },
          {
            url: null,
            name: '참조/열람문서함',
            slug: 'faq',
            icon: 'FileIcon'
          }
        ]
      }
      newMenuData.push(approval)

      this.sidebarItems = newMenuData
    },

    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },

    gnbClickMenu (index) {
      if (index === 0) {
        this.showSidebar()
      } else if (index === 1) {
      } else if (index === 2) {
      } else if (index === 3) {
      } else if (index === 4) {
      }
    },

    // Mypage로 이동
    moveMyPage () {
      this.$router.push(`/m/project/${this.$route.params.proj_id}/mypage/info-update`)
    }

  },
  async beforeCreate () {
    await this.$store.dispatch('USER_INFO')
    const userId = this.$store.state.auth.userInfo.id
    let projId = localStorage.getItem(`save_proj_id_${userId}`)
    projId = ''

    if (!projId || projId <= 0) {

      // 게시물 불러오기
      const projectList = await this.loadMyProjectList()
      if (projectList.length > 0) {
        const lastProjectId = projectList[0].id

        const userId = this.$store.state.auth.userInfo.id
        localStorage.setItem(`save_proj_id_${userId}`, lastProjectId)
        projId = localStorage.getItem(`save_proj_id_${userId}`)

        await this.$router.replace(`/m/project/${projId}`)
      } else {
        alert('참여가능한 프로젝트가 없습니다.')
        await this.$router.replace('/m/login')
      }

    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    this.loadMenuList()
  }
}

</script>

<style>
[dir] input[readonly='readonly'] {
  background-color: #fafafa;
}

[dir] textarea[readonly='readonly'] {
  background-color: #fafafa;
}

[dir] .file-input .vs-con-input .vs-inputx {
  background-color: #ffffff;
}

[dir] .con-select .vs-select--input {
  background-color: #ffffff;
}

[dir] .vdp-datepicker input[readonly='readonly'] {
  background-color: #ffffff;
}

/* 페이지네이션 중앙 정렬 */
[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(1) {
  display: none !important;
}

[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(2) {
  width: 100% !important;
  justify-content: center !important;
}

/* 페이지네이션 현재페이지 색상 */
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .effect,
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .vs-pagination--buttons:hover {
  background: rgba(var(--vs-secondary), 1) !important;
}

/* 리스트 스타일 */
.dot {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  border-radius: 10px;
  display: inline-block;
  background-color: #6670CB;
}

.dot.red {
  background-color: #fb0000;
}

.dot.yellow {
  background-color: #FFD600;
}

/* 테이블 스타일 */
ul.table {
  width: 100%;
}

ul.table > li {
  display: grid;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #cdcdcd;
  grid-template-rows: minmax(52px, 100%);
}

ul.table > li.tbody {
  background-color: #fff;
}

ul.table > li.tbody > span {
  font-weight: normal !important;
}

ul.table > li > span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #cdcdcd;
  padding: 6px;
  font-weight: 500;
}

ul.table > li > span:first-child {
  border-left: none;
}

ul.table.table-2 > li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table.table-3 > li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table.table-4 > li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table.table-5 > li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table.table-6 > li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table.table-7 > li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table.table-8 > li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table.table-9 > li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table.table-10 > li {
  grid-template-columns:50px repeat(9, minmax(0, 1fr));
}

ul.table.table-no > li {
  grid-template-columns: 60px minmax(0, 100%);
}

ul.table > li.table-2-li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table > li.table-3-li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table > li.table-4-li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table > li.table-5-li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table > li.table-6-li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table > li.table-7-li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table > li.table-8-li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table > li.table-9-li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table > li.table-10-li {
  grid-template-columns:50px repeat(9, minmax(0, 1fr));
}

ul.table > li.table-no-li {
  grid-template-columns: 60px minmax(0, 100%);
}

.vs-row .border {
  border: 1px solid #cdcdcd;
  text-align: center;
  background-color: #F9F9F9;
}

.bg-fff {
  background-color: #fff;
}

.border-left {
  border-left: 1px solid #cdcdcd !important;
}

.border-right {
  border-right: 1px solid #cdcdcd !important;
}

.border-bottom {
  border-bottom: 1px solid #cdcdcd !important;
}

.border-top {
  border-top: 1px solid #cdcdcd !important;
}

.title {
  font-weight: 500;
}

.no-drag {
  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

</style>

